import React, { useEffect, useState } from 'react';
import {
    CCard,
    CCardBody,
    CCardHeader,
    CRow,
    CCol,
    CTable,
    CTableHead,
    CTableRow,
    CTableHeaderCell,
    CTableBody,
    CTableDataCell,
    CButton,
} from '@coreui/react-pro';
import { useStore } from '../../contexts/StoreContext';
import * as DomicilappService from "../../services/DomicilappService";
import { TransactionDataItem } from '../../types/transaction';

export const FinanceBalance: React.FC = () => {
    const { storeId, setStoreId, storeDetails } = useStore();
    const [transactions, setTransactions ] = useState<TransactionDataItem[]>([]);

    useEffect(() => {
        console.log("Entra aqui 25");
        if (storeId) {
            console.log("Entra aqui 27");
            setTransactions([]);

            DomicilappService.getTransactionsByStore(storeId).then((response) => { 
                if (response.status === 200) {
                    
                    setTransactions(response.data.items);
                }
            });
        }
    }, [storeId])

    // const transactions = [
    //     { id: 'TX-901', type: 'Ingreso', description: 'Pago de Orden #1024 (Balance)', amount: '+$34.500', date: '2026-09-14 10:15', status: 'completed' },
    //     { id: 'TX-902', type: 'Retiro', description: 'Transferencia a cuenta bancaria', amount: '-$150.000', date: '2026-09-13 18:00', status: 'completed' },
    // ];

    const currencyFormat = new Intl.NumberFormat('es-CO', {
        style: 'currency',
        currency: 'COP',
        minimumFractionDigits: 2
    });

    return (
        <>
            {/* TARJETA DE SALDO Y ACCIONES */}
            <CRow className="mb-4">
                <CCol md={6} lg={5}>
                    <CCard className="border border-secondary-subtle shadow-none bg-body rounded-3">
                        <CCardBody className="p-4 text-body">
                            <span className="text-body-secondary small text-uppercase fw-semibold">Saldo Disponible</span>
                            <h2 className="display-6 fw-bold my-2 text-body">{currencyFormat.format(parseFloat(storeDetails.balance))}</h2>
                            <p className="text-body-secondary small mb-3">Fondos listos para transferencia a tu cuenta registrada.</p>
                            {/* <CButton
                                color="dark"
                                size="sm"
                                className="fw-medium text-white px-3"
                            >
                                Solicitar Retiro
                            </CButton> */}
                        </CCardBody>
                    </CCard>
                </CCol>
            </CRow>

            {/* HISTORIAL DE MOVIMIENTOS */}
            <CCard className="border border-secondary-subtle shadow-none bg-body rounded-3">
                <CCardHeader className="bg-body border-bottom border-secondary-subtle py-3 text-body">
                    <h6 className="mb-0 fw-bold">Movimientos de Billetera y Saldos</h6>
                </CCardHeader>
                <CCardBody className="p-0">
                    <CTable align="middle" responsive hover className="mb-0 text-body">
                        <CTableHead className="bg-body-tertiary border-bottom border-secondary-subtle">
                            <CTableRow>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">ID Transacción</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Tipo</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Descripción</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Monto</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Fecha</CTableHeaderCell>
                                <CTableHeaderCell className="text-body-secondary small fw-semibold">Estado</CTableHeaderCell>
                            </CTableRow>
                        </CTableHead>
                        <CTableBody>
                            {transactions.map((tx) => {
                                const isPositive = tx.charges_statuses_id === 1;
                                return (
                                    <CTableRow key={tx.id} className="border-bottom border-secondary-subtle">
                                        <CTableDataCell className="fw-semibold text-body">{"TX-"+tx.id}</CTableDataCell>
                                        <CTableDataCell className="text-body text-capitalize">{tx.transaction_type}</CTableDataCell>
                                        <CTableDataCell className="text-body">{tx.description}</CTableDataCell>
                                        <CTableDataCell className={`fw-semibold ${isPositive ? 'text-success' : 'text-body'}`}>
                                            {currencyFormat.format(tx.price)}
                                        </CTableDataCell>
                                        <CTableDataCell className="text-body-secondary small">{tx.created_at}</CTableDataCell>
                                        <CTableDataCell>
                                            <span className="bg-body-tertiary text-success border border-success-subtle badge bg-success-subtle text-success-emphasis border border-success-subtle rounded-pill px-2 py-1 font-normal">
                                                Completado
                                            </span>
                                        </CTableDataCell>
                                    </CTableRow>
                                );
                            })}
                        </CTableBody>
                    </CTable>
                </CCardBody>
            </CCard>
        </>
    );
};

export default FinanceBalance;